"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaximillionFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract TEther",
                name: "tEther_",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
        ],
        name: "repayBehalf",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "contract TEther",
                name: "tEther_",
                type: "address",
            },
        ],
        name: "repayBehalfExplicit",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tEther",
        outputs: [
            {
                internalType: "contract TEther",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506040516103363803806103368339818101604052602081101561003357600080fd5b5051600080546001600160a01b039092166001600160a01b03199092169190911790556102d1806100656000396000f3fe6080604052600436106100345760003560e01c8063367b7f051461003957806394635c46146100695780639f35c3d51461009a575b600080fd5b6100676004803603604081101561004f57600080fd5b506001600160a01b03813581169160200135166100c0565b005b34801561007557600080fd5b5061007e610273565b604080516001600160a01b039092168252519081900360200190f35b610067600480360360208110156100b057600080fd5b50356001600160a01b0316610282565b60003490506000826001600160a01b03166317bfdfbc856040518263ffffffff1660e01b815260040180826001600160a01b03166001600160a01b03168152602001915050602060405180830381600087803b15801561011f57600080fd5b505af1158015610133573d6000803e3d6000fd5b505050506040513d602081101561014957600080fd5b50519050808211156101fb57826001600160a01b031663e597461982866040518363ffffffff1660e01b815260040180826001600160a01b03166001600160a01b031681526020019150506000604051808303818588803b1580156101ad57600080fd5b505af11580156101c1573d6000803e3d6000fd5b505060405133935084860380156108fc02935091506000818181858888f193505050501580156101f5573d6000803e3d6000fd5b5061026d565b826001600160a01b031663e597461983866040518363ffffffff1660e01b815260040180826001600160a01b03166001600160a01b031681526020019150506000604051808303818588803b15801561025357600080fd5b505af1158015610267573d6000803e3d6000fd5b50505050505b50505050565b6000546001600160a01b031681565b6000546102999082906001600160a01b03166100c0565b5056fea265627a7a72315820240460fbbb7500a5e58a73b2d4f5a1e660becb729fa1df3a7ea9b906068df32f64736f6c63430005100032";
class MaximillionFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(tEther_, overrides) {
        return super.deploy(tEther_, overrides || {});
    }
    getDeployTransaction(tEther_, overrides) {
        return super.getDeployTransaction(tEther_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MaximillionFactory = MaximillionFactory;
MaximillionFactory.bytecode = _bytecode;
MaximillionFactory.abi = _abi;
//# sourceMappingURL=MaximillionFactory.js.map